
import { Card, Col, Form, Row, Skeleton, Space, Input, Select } from 'antd'
import { ButtonBack, ButtonSaveDraft, ButtonSubmit } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import { useAtom } from 'jotai';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useDeptRepo from "../../services/repo/useDepartmentRepo";
import useOrgRepo from "../../services/repo/useOrgRepo";
import useDivRepo from "../../services/repo/useDivisionRepo";
import usePosRepo from "../../services/repo/usePositionRepo";
import useWBSRepo from "../../services/repo/useWBSInitRepo";
import { INIT_WBS, wbsAtom } from 'store/WBS/wbs';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import Constant from 'utils/Constants';
import CustomAlert from 'utils/CustomAlert';
import { checkErrorFormToOpenCollapse, setFieldValues } from 'utils/Helper';
import { dismissToast, errorToast, loadingToastId, successToast } from 'utils/Toast';
import { CustomFormItemText, CustomFormItemInteger, CustomFormItemSelectDropdown, CustomFormItemTextArea, CustomFormItemDate, CustomFormItemSwitch } from 'components/Common/CustomFormItem';
import SectionWbsTask from './Section/SectionWbsTask';



export default function ManageWbs() {
    const { wbsId } = useParams();
    const isEditMode = Boolean(wbsId);
    useTopbarTitleHooks(`${isEditMode ? "Edit" : "Create"} Work Breakdown Structure`);
    const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false)
    const { isLoading: isLoadingDivList, getDivisionList } = useDivRepo(false)
    const { isLoading: isLoadingDeptList, getDepartmentList } = useDeptRepo(false)
    const { isLoading: isLoadingPosList, getPositionList } = usePosRepo(false)
    const { isLoading: isLoadingWbs, submitWBS, saveDraftWBS, getWBSById } = useWBSRepo(false);
    const [isFormLoading, setIsFormLoading] = useState(false);

    const [wbsTaskList, setWbsTaskList] = useState([]);
    const [dataField, setDataField] = useAtom(wbsAtom);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [activeKey, setActiveKey] = useState(['1', '2']);
    const [errorList, setErrorList] = useState(false);
    const isLoadingPrivilege = useRef(true);

    const [filters, setFilters] = useState({
        orgId: null,
        divId: null,
        deptId: null,
        posId: null,
        wfId: null
    })

    const [tableParams, setTableParams] = useState({
        pageNumber: 1,
        pageSize: 10,
        filter: { ...filters },
        orderBy: "divName",
        isAscending: true
    });


    const fetchCheckPrivilege = async () => {
        loadingToastId(Constant.message.loading, PRIVILEGE_ID.AddEditWbs)
        dismissToast(PRIVILEGE_ID.AddEditWbs)
        if (wbsId) await fetchGetWbsById(wbsId)
        isLoadingPrivilege.current = false
    }

    const fetchGetWbsById = async (id) => {
        setIsFormLoading(true);
        const response = await getWBSById({ wbsId: id });

        if (response?.detail === 'OK' && response?.status === 200) {
            const data = response?.data;

            // Set value form
            form.setFieldsValue({
                orgId: data.orgId,
                orgAddress: data.orgAddress,
                posId: data.posId,
                employeeName: data.submissionUserFirstName,
                posResourceTotal: data.posResourceTotal,
                divId: data.divId,
                deptId: data.deptId,
            });

            // Set Atom State
            setDataField(prev => ({
                ...prev,
                wbsId: data.wbsId,
                orgId: data.orgId,
                orgAddress: data.orgAddress,
                posId: data.posId,
                posResourceTotal: data.posResourceTotal,
                divId: data.divId,
                deptId: data.deptId,
                employeeName: data.submissionUserFirstName,
            }));

            // Set Task List

            setWbsTaskList(data.wbsContentList.map((item, index) => ({
                id: Date.now() + index,
                taskDescription: item.wbsContentTask,
                remark: item.wbsContentRemark,
            })));


            // Chaining dropdown
            if (data.orgId) fetchDataDivision(data.orgId);
            if (data.divId) fetchDataDepartment(data.divId);
            if (data.deptId) fetchDataPosition(data.deptId);
        } else {
            errorToast('Gagal mengambil data WBS');
        }

        setIsFormLoading(false);
    };

    const validateList = () => {
        return wbsTaskList.length > 0;
    };

    const doSave = async () => {
        const values = form.getFieldsValue();
        debugger
        const payload = {
            wbsId: dataField?.wbsId || '',
            orgId: values.orgId.value,
            orgAddress: values.orgAddress || '',
            posId: values.posId,
            wbsContentList: wbsTaskList.map((item, index) => ({
                wbsContentNo: String(index + 1),
                wbsContentTask: item.taskDescription,
                wbsContentRemark: item.remark
            }))
        };

        loadingToastId(Constant.message.savingData, payload)
        const response = await submitWBS(payload);
        dismissToast(payload);

        if (response?.detail === 'OK' && response?.status === 200) {
            successToast('WBS berhasil disubmit');
            navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.workBreakdownStructure.index, { replace: true });
        } else {
            errorToast(Constant.message.fail);
        }
    };

    const doSaveDraft = async () => {
        const values = form.getFieldsValue();
        debugger
        const payload = {
            wbsId: dataField?.wbsId || '',
            orgId: values.orgId.value,
            orgAddress: values.orgAddress || '',
            posId: values.posId,
            wbsContentList: wbsTaskList.map((item, index) => ({
                wbsContentNo: String(index + 1),
                wbsContentTask: item.taskDescription,
                wbsContentRemark: item.remark
            }))
        };

        loadingToastId(Constant.message.savingData, payload)
        const response = await saveDraftWBS(payload);
        dismissToast(payload);

        if (response?.detail === 'OK' && response?.status === 200) {
            successToast(Constant.message.saveDataSuccess)
            navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.workBreakdownStructure.index, { replace: true })
            // setDataField(prev => ({ ...prev, wbsId: response?.data?.wbsId || prev.wbsId }));
        } else {
            errorToast(Constant.message.fail);
        }
    };

    const validateSave = () => {
        form.validateFields()
            .then(() => {
                if (validateList()) {
                    doSave();
                } else {
                    errorToast(Constant.message.errorForm);
                }
            })
            .catch((errorInfo) => {
                errorToast(Constant.message.errorForm);
                if (checkErrorFormToOpenCollapse(errorInfo?.errorFields, [])) {
                    setActiveKey(prev => ([...new Set([...prev, '1'])]));
                }
                if (!validateList()) {
                    setActiveKey(prev => ([...new Set([...prev, '2'])]));
                }
            });
    };


    const handleFormSubmit = (e) => {
        e.preventDefault();
        CustomAlert.confirm({
            title: 'Submit WBS!',
            description: 'Are you sure you want to submit this WBS?',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'primary',
            onConfirmButton: () => validateSave()
        });
    };

    const handleFormSaveDraft = e => {
        e.preventDefault();
        form.validateFields().then(() => {
            if (!validateList()) return errorToast('WBS task list tidak boleh kosong');
            CustomAlert.confirm({
                title: 'Save as Draft',
                description: 'Are you sure you want to save this WBS as draft?',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'primary',
                onConfirmButton: doSaveDraft
            });
        }).catch(() => errorToast(Constant.message.errorForm));
    };


    // Org dropdown
    const [orgOptions, setOrgOptions] = useState([])
    const fetchDataOrg = async () => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            orderBy: "orgId",
            isAscending: true,
            filter: {
                orgId: null,
                orgName: "",
                status: "true",
            },
        }

        const res = await getOrgList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {

            const options = res.data.content.map(item => ({
                label: item?.orgName,
                value: item?.orgId,
            }));

            setOrgOptions(options);

            if (options.length === 1) {
                const onlyOption = options[0];

                form.setFieldsValue({ orgId: onlyOption }); // isinya harus { label, value }
                setFilters((prev) => ({ ...prev, orgId: onlyOption.value }));

                setTableParams((prev) => ({
                    ...prev,
                    filter: {
                        ...prev.filter,
                        orgId: onlyOption.value
                    }
                }));
                fetchDataDivision(onlyOption.value);
            }
        }
    }


    const [divOptions, setDivOptions] = useState([])
    const fetchDataDivision = async (orgId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divCode: "",
                divName: "",
                orgId: orgId,
                divId: null,
                status: "true",
            },
            orderBy: "divCode",
            isAscending: true
        }
        setDivOptions([])

        const res = await getDivisionList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {
            setDivOptions(() => {
                return res?.data?.content.map(item => {
                    return {
                        value: item?.divId,
                        label: item?.divName
                    }
                })
            })
        }
    }


    const [deptOptions, setDeptOptions] = useState([])
    const fetchDataDepartment = async (divId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divId: divId,
                deptName: "",
                status: "true",
            },
            orderBy: "deptName",
            isAscending: true
        }

        const res = await getDepartmentList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {
            setDeptOptions(res.data?.content.map(item => ({
                label: item.deptName,
                value: item.deptId
            })))
        } else {
            setDeptOptions([])
        }
    }

    const [positionOptions, setPositionOptions] = useState([])
    const fetchDataPosition = async (deptId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                deptId: deptId,
                posName: "",
                status: "true"
            },
            orderBy: "posName",
            isAscending: true
        }

        const res = await getPositionList(payload)

        debugger;
        if (res?.detail === 'OK' && res?.status === 200) {

            setPositionOptions(res.data?.content.map(item => ({
                label: item.posName,
                value: item.posId,
                submissionUserFullName: item.submissionUserFullName,
                posResourceTotal: item.posResourceTotal
            })))
        } else {
            setPositionOptions([])
        }
    }




    useEffect(() => {
        fetchDataOrg();
        fetchCheckPrivilege()

        if (isEditMode) {
            fetchGetWbsById(wbsId);
        }
        return () => {
            setDataField(INIT_WBS);
        };
    }, [wbsId])

    return (
        <div>
            <Card>
                {isFormLoading ? (
                    <Skeleton active paragraph={{ rows: 10 }} />
                ) : (
                    <Form form={form} layout="horizontal" labelAlign="left">
                        <Row gutter={[16]}>
                            <Col xs={24} sm={24} md={12}>
                                <CustomFormItemSelectDropdown
                                    nameFormItem="orgId"
                                    label="Organization"
                                    showSearch={true}
                                    value={dataField?.orgId}
                                    rules={[{ required: true, message: 'Please select Organization' }]}
                                    placeholder="Select Organization"
                                    loading={isLoadingOrgList}
                                    options={orgOptions}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    onChange={(value) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            orgId: value || null,
                                            divId: null,
                                            deptId: null,
                                            posId: null,
                                        }));
                                        form.setFieldsValue({ divId: undefined, deptId: undefined, posId: undefined });
                                        if (value) fetchDataDivision(value);
                                        else setDivOptions([]);
                                    }}

                                />
                            </Col>

                            <Col xs={24} sm={24} md={12}>
                                <CustomFormItemText
                                    nameFormItem="employeeName"
                                    label="Nama Lengkap"
                                    placeholder='Silahkan Pilih posisi'
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                    disabled={true}
                                    value={dataField?.employeeName}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    onChange={(e) => {
                                        setDataField(prev => ({
                                            ...prev,
                                            employeeName: e.target.value
                                        }))
                                    }}
                                />
                            </Col>

                            <Col xs={24} sm={24} md={12}>
                                <CustomFormItemSelectDropdown
                                    nameFormItem="divId"
                                    label="Division/Unit Kerja"
                                    showSearch={true}
                                    value={dataField?.divId}
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                    placeholder="Select Division"
                                    loading={isLoadingDivList}
                                    // disabled={!dataField?.orgId}
                                    options={divOptions}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    onChange={(value) => {
                                        setDataField((prev) => ({
                                            ...prev,
                                            divId: value || null,
                                            deptId: null, // reset department jika division berubah
                                        }));

                                        form.setFieldsValue({ deptNameOption: undefined }); // reset field di form
                                        if (value) {
                                            fetchDataDepartment(value); // chaining
                                        } else {
                                            setDeptOptions([]);
                                        }
                                    }}

                                />
                            </Col>

                            <Col xs={24} sm={24} md={12}>
                                <CustomFormItemInteger
                                    nameFormItem="posResourceTotal"
                                    label="Jumlah SDM Saat Ini"
                                    required={true}
                                    rules={[{ required: true, message: 'Fill in Jumlah SDM Saat Ini' }]}
                                    disabled={true}
                                    min={1}
                                    max={1000}
                                    placeholder="Enter Is (1 - 1000)"
                                    alignView="right" // 
                                    value={dataField?.posResourceTotal}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    onChange={(value) => {
                                        setDataField(prev => ({
                                            ...prev,
                                            posResourceTotal: value
                                        }))
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row gutter={[16]}>
                            <Col xs={24} sm={24} md={12}>
                                <CustomFormItemSelectDropdown
                                    nameFormItem="deptId"
                                    label="Department"
                                    showSearch={true}
                                    value={dataField?.deptId}
                                    rules={[{ required: true }]}
                                    placeholder="Select Department"
                                    loading={isLoadingDeptList}
                                    disabled={!dataField?.divId}
                                    options={deptOptions}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    onChange={(value) => {
                                        setDataField((prev) => ({
                                            ...prev,
                                            deptId: value || null,
                                            positionId: null, // reset position saat dept berubah
                                        }));

                                        form.setFieldsValue({ positionNameOption: undefined }); // reset form field

                                        if (value) {
                                            fetchDataPosition(value); // chaining
                                        } else {
                                            setPositionOptions([]);
                                        }
                                    }}

                                />
                            </Col>


                            <Col xs={24} sm={24} md={12}>
                                <CustomFormItemTextArea
                                    nameFormItem="orgAddress"
                                    label="Lokasi Kantor"
                                    required={true}
                                    value={dataField?.orgAddress}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 12 }}
                                    onChange={(e) => setDataField(prev => ({ ...prev, orgAddress: e.target.value }))}
                                    placeholder="Fill in Office Location"
                                />
                            </Col>
                        </Row>

                        <Row gutter={[16]}>
                            <Col xs={24} sm={24} md={12}>
                                <CustomFormItemSelectDropdown
                                    nameFormItem="posId"
                                    label="Position/Jabatan"
                                    showSearch={true}
                                    value={dataField?.posId}
                                    rules={[{ required: true }]}
                                    placeholder="Select Position"
                                    loading={isLoadingPosList}
                                    disabled={!dataField?.deptId}
                                    options={positionOptions}
                                    labelCol={{ span: 8 }}
                                    wrapperCol={{ span: 16 }}
                                    onChange={(value) => {
                                        const selected = positionOptions.find(opt => opt.value === value);
                                        //alert(selected?.submissionUserFullName + selected?.posResourceTotal)
                                        setDataField(prev => ({
                                            ...prev,
                                            posId: value || null,
                                            employeeName: selected?.submissionUserFullName || "", // <-- update employee name
                                            posResourceTotal: selected?.posResourceTotal || ""
                                        }))

                                        form.setFieldsValue({
                                            employeeName: selected?.submissionUserFullName || "",
                                            posResourceTotal: selected?.posResourceTotal || ""
                                        });
                                    }}
                                />
                            </Col>
                        </Row>
                        <Col xs={24}>
                            <div style={{ height: 50 }} />
                        </Col>

                        {/* <Col xs={24} sm={24}>
                            <Row gutter={[16]}>

                                <Col xs={24} sm={24} lg={12}>
                                    <CustomFormItemDate
                                        nameFormItem="dateDataCollection"
                                        label="Tanggal Penggambilan Data"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                        value={dataField?.dateDataCollection}
                                    // isView={true}
                                    />
                                </Col>
                            </Row>
                        </Col> */}

                        {/* </Row> */}

                        <Row gutter={[16]}>
                            <Col span={24}>
                                <SectionWbsTask
                                    isView={false}
                                    form={form}
                                    onChangeTaskList={(newList) => setWbsTaskList(newList)}
                                    initialTaskList={wbsTaskList} 
                                />

                            </Col>
                        </Row>

                        <div style={{ display: "flex", gap: "10px", margin: "10px 0" }}>
                            <ButtonBack onClick={() => navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.workBreakdownStructure.index)} disabled={isLoadingWbs} />
                            <ButtonSaveDraft
                                onClick={handleFormSaveDraft}
                                loading={isLoadingWbs}
                                disabled={isLoadingWbs}
                            />
                            <ButtonSubmit
                                onClick={handleFormSubmit}
                                loading={isLoadingWbs}
                                disabled={isLoadingWbs}
                            />
                        </div>
                    </Form>
                )}
            </Card>
        </div>
    )

}
